import React, { useEffect, useState } from "react";
import { MapPin, Edit } from "lucide-react";
import { Badge } from "../../../../components/ui/badge";
import Button from "../../../../components/ui/Button";
import { ServiceArea } from "../../../admin/models/ServiceArea.model";
import { useSelector } from "react-redux";
import { RoleEnum } from "../../../shared/model";
import { getUserById, useAppDispatch } from "../../../../redux";
import { useTranslation } from "react-i18next";

interface ServiceAreaDisplayProps {
    userId?: string;
    selectedServiceAreas: ServiceArea[];
    onEdit?: () => void;
    showEditIcon?: boolean;
}

const ServiceAreaDisplay: React.FC<ServiceAreaDisplayProps> = ({
    userId,
    selectedServiceAreas = [],
    onEdit,
    showEditIcon = false
}) => {
    const { t } = useTranslation();
    const { user } = useSelector((state: any) => state.auth);
    const targetUserId = userId || user?.id;
    console.log(targetUserId);
    const dispatch = useAppDispatch();
    const [userData, setUserData] = useState<any>(null);
    useEffect(() => {

        const getUserData = async () => {
            if (targetUserId) {
                const response = await dispatch(getUserById({ id: targetUserId }));
                setUserData(response.payload);
            }
        };
        getUserData();
    }, [targetUserId]);
    if (Number(user?.role?.id) === RoleEnum.internationl_professional || Number(userData?.role?.id) === RoleEnum.internationl_professional) {
        return (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
                {/* <MapPin className="w-12 h-12 mx-auto mb-3 text-gray-300" /> */}
                {<h1>{t("serviceAreaDisplay.internationalProMessage")}</h1>}
            </div>
        );
    }
    else {
        if (!selectedServiceAreas || selectedServiceAreas.length === 0) {
            return (
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
                    <h1>{t("serviceAreaDisplay.noServiceAreasSelected")}</h1>
                </div>
            );
        }
    }

    return (
        <div className="space-y-4">
            <div>
                <div className="flex items-center justify-between mb-3">
                    <h3 className="text-lg font-semibold flex items-center gap-2">
                        <MapPin className="w-5 h-5 text-blue-600" />
                        {t("serviceAreaDisplay.serviceAreas")}
                    </h3>
                </div>
                <div className="grid grid-cols-1 gap-3">
                    {selectedServiceAreas?.map((area) => (
                        <div
                            key={area.id}
                            className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow"
                        >
                            <div className="flex items-start justify-between mb-2">
                                <h4 className="font-medium text-gray-900">{area.name}</h4>
                                <div className="flex gap-1">
                                    {area.emergencyServices && (
                                        <Badge variant="destructive" className="text-xs">
                                            {t("serviceAreaDisplay.emergency")}
                                        </Badge>
                                    )}
                                </div>
                            </div>
                            <p className="text-sm text-gray-600 mb-3">
                                {area.province && area.country?.name
                                    ? `${area.province}, ${area.country.name}`
                                    : t("serviceAreaDisplay.locationNotAvailable")
                                }
                            </p>

                            {/* Show service types if available */}
                            {area.serviceTypes && area.serviceTypes.length > 0 && (
                                <div>
                                    <div className="text-xs font-medium text-gray-500 mb-2 uppercase tracking-wide">
                                        {t("serviceAreaDisplay.serviceTypes")}
                                    </div>
                                    <div className="flex flex-wrap gap-1">
                                        {area.serviceTypes.map((serviceType, index) => (
                                            <Badge
                                                key={`${area.id}-${index}`}
                                                variant="outline"
                                                className="text-xs"
                                            >
                                                {serviceType}
                                            </Badge>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServiceAreaDisplay;
